import React from "react";
import PropTypes from "prop-types";
import {makeStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import { Badge } from "react-bootstrap";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  CircularProgress,
} from "@material-ui/core";

const headRows = [
  {
    id: "system",
    numeric: false,
    disablePadding: false,
    label: "Sistem",
  },
  {
    id: "A.S.A ",
    numeric: false,
    disablePadding: false,
    label: "Ad, soyad, ata adı",
  },
  {
    id: "company",
    numeric: false,
    disablePadding: false,
    label: "Şirkət ",
  },
  {
    id: "directorate",
    numeric: false,
    disablePadding: false,
    label: "Direktorluq ",
  },
  {
    id: "department ",
    numeric: false,
    disablePadding: false,
    label: "Departament ",
  },{
    id: "branch",
    numeric: false,
    disablePadding: false,
    label: "Şöbə ",
  },{
    id: "division",
    numeric: false,
    disablePadding: false,
    label: "Bölmə ",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Struktur növü",
  },
  {
    id: "supervisor",
    numeric: false,
    disablePadding: false,
    label: "Birbaşa Rəhbər ",
  },
  {
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Struktur növü",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Barmaq izi sayı",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Barmaq izləri ",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Barmaq izi qeydiyyat tarixi",
  },
  {
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Barmaq izi qeydiyyat qurğusu ",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Kart sayı ",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Kart adı ",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Kart nömrəsi",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Qurğu sayı ",
  },
  {
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Qurğular",
  },{
    id: "structurType",
    numeric: false,
    disablePadding: false,
    label: "Qurğu məkanı",
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Fin kod",
  },

  {
    id: "duty",
    numeric: false,
    disablePadding: true,
    label: "Vəzifə",
  },

  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Vəziyyət",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Qeydiyyat statusu",
  },
  
  // {
  //   id: "tools",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Əməliyyatlar",
  // },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,

  } = props;

  return (
    <TableHead>
      <TableRow>

        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" && row.id !== "fullName" && row.id !== "status" && row.id !== "cardCount" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  locals,
  isLoading,
  setChooseLocalId,
  setOpenView,
  deleteLocalsIds,
  setDeleteLocalsIds,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  count,
  isError,
  setShowLog,


}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  function handleRequestSort(property) {
    const isDesc = sortField === property && orderBy === 'desc';
    setOrderByTable(isDesc ? 'asc' : 'desc');

    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = locals.map((n) => n.id);
      setDeleteLocalsIds(newSelecteds);
      return;
    }
    setDeleteLocalsIds([]);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteLocalsIds.indexOf(id) !== -1;

  return (
    <div className={`${classes.root} NoShadow`}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
   

        <div className={classes.tableWrapper}>
          {locals ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteLocalsIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={locals.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}

              />
              <TableBody>
                {locals.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >

                  
<TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>

                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "INACTIVE"
                              ? "info"
                              : row.status === "ACTIVE" ? "success" : "-"
                          }
                        >
                          {row.status === "INACTIVE"
                            ? "Deaktiv"
                            : row.status === "ACTIVE" &&
                            "Aktiv"}
                        </Badge>
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.fullName}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.pin}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.cardCount}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.duty}
                      </TableCell>
                 
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : !locals && !locals.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}

        </div>
        {count > 10 && (
          <TablePagination
          rowsPerPageOptions={[5, 10, 25,50]}

            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  );
}
